module.exports = "<div class=\"logout\">\n  <h2 i18n=\"@@loggingOut\">Logging Out...</h2>\n</div>\n\n<app-spinner [status]=\"status\"></app-spinner>"